import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2/call_intelligence.pb';
import { API as CallQualityAPI } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-quality/v1/api.pb';
import { FeatureMockRouter } from '@frontend/demo-interceptors';
import { MockAPIRouter } from '@frontend/fetch';
import { BaseMockRouterContext } from './types';

const IS_DEMO_HEADER = 'X-Is-Demo';

export const CallIntelFeedbackMockRouter: FeatureMockRouter<BaseMockRouterContext> = {
  addMockRouterEndpoints: (router) => {
    router.schemaEndpoint(CallIntelligenceService.SubmitFeedback, (request, _params, next) => {
      if (request.headers.get(IS_DEMO_HEADER) === 'true') {
        return MockAPIRouter.json({});
      }
      next();
      return null;
    });

    router.schemaEndpoint(CallQualityAPI.SubmitFeedback, (request, _params, next) => {
      if (request.headers.get(IS_DEMO_HEADER) === 'true') {
        return MockAPIRouter.json({});
      }
      next();
      return null;
    });
  },
};
